import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { PublicClientApplication } from "@azure/msal-browser";
import { loginRequest, msalConfig } from "../../authConfig";

const msalInstance = new PublicClientApplication(msalConfig);

export const fetchDetails = createAsyncThunk(
  "data/fetchDetails",
  async (searchQuery, { rejectWithValue }) => {
    try {
      await msalInstance.initialize();
      const accounts = msalInstance.getAllAccounts();
      if (accounts.length === 0) {
        throw new Error("No accounts found. User needs to log in.");
      }
      const response = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      });

      const token = response.accessToken;

      const [listResponse, jsonResponse, sasResponse, searchResponse] =
        await Promise.all([
          axios.get(
            "https://devopsfunctapp4497.azurewebsites.net/api/GetListOfPaths",
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          ),
          axios.get(
            "https://devopsfunctapp4497.azurewebsites.net/api/GetValuesFromJSON",
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          ),
          axios.get("https://devopsfunctapp4497.azurewebsites.net/api/GetSaasURL", {
            headers: { Authorization: `Bearer ${token}` },
          }),
          axios.get("https://devopsfunctapp4497.azurewebsites.net/api/GetSearch", {
            params: { name_of_document: searchQuery },
            headers: { Authorization: `Bearer ${token}` },
          }),
        ]);

      const listPaths = listResponse.data;
      const metadata = jsonResponse.data;
      const sasUrls = sasResponse.data;
      const searchResults = searchResponse.data;

      const metadataPaths = new Set(metadata.map((item) => item.path));
      const missingPaths = listPaths.filter((path) => !metadataPaths.has(path));

      const modifiedData = [
        ...metadata,
        ...missingPaths.map((path) => ({
          path,
          name_of_document: path.split("/").pop(),
          summary: "No summary available",
          timestamp: new Date().toISOString(),
          author_name: "Unknown",
          fullPath: `https://devxopsstor3563.blob.core.windows.net/${path}`,
        })),
      ];
      return { data: modifiedData, sasUrls, searchResults };
    } catch (error) {
      console.error("Error fetching details:", error.message);
      return rejectWithValue(error.message);
    }
  }
);
